import { CancelToken } from "axios";
import {
  VenipakDeliveryPromiseDependantData,
  VenipakDeliveryPromise,
} from "@/types";
import {DeliveryApi} from "@/api/delivery.api";

export class VenipakDeliveryApi extends DeliveryApi {

  getAddresses(
    query: string,
    language: string,
    cancelToken?: CancelToken
  ): Promise<string[]> {
    return this.axios
      .get<{ session_token: string; suggestions: Array<{ placePrediction: { placeId: string; text: { text: string } } }> }>(
        `/api/address/autocomplete`,
        {
          params: {
            input: query,
            city: language, // TODO: quick hack for now so we can use Jurmala quick
            restrictLocation: false,
            session_token: this.sessionToken ?? undefined,
          },
          cancelToken,
        }
      )
      .then((r) => {
        this.sessionToken = r.data.session_token;
        const apartmentSuffix = this.extractApartmentSuffix(query);
        return this.processSuggestions(r.data.suggestions, apartmentSuffix);
      });
  }

  calculateDelivery(
      saleId: number,
      data: VenipakDeliveryPromiseDependantData,
      cancelToken?: CancelToken
  ): Promise<VenipakDeliveryPromise> {
    return this.axios
        .post<{ promise: VenipakDeliveryPromise }>(
            "/delivery/venipak/promise",
            { saleId, ...data },
            { cancelToken }
        )
        .then((r) => r.data.promise);
  }
}
